<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    >
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>
<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        accidentStateOptions: [],
        form: [
          {
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          {
            label: '事故状态',
            value: 'accidentState',
            type: 'select',
            placeholder: '请选择事故状态',
            default: '-1',
          },
          {
            label: '报案日期',
            value: 'reportTime',
            type: 'date',
            placeholder: '报案日期',
            attr: {
              type: 'daterange',
            },
          },
          {
            label: '出险日期',
            value: 'time',
            type: 'date',
            placeholder: '出险日期',
            attr: {
              type: 'daterange',
            },
          },
          {
            label: '创建日期',
            value: 'createTime',
            type: 'date',
            placeholder: '创建日期',
            attr: {
              type: 'daterange',
            },
          },
          {
            label: '申请单号',
            value: 'busiCode',
            type: 'input',
            placeholder: '请输入申请单号',
          },
        ],
      },
    };
  },
  methods: {
    sub (searchBoxData) {
      if (searchBoxData.reportTime && searchBoxData.reportTime.length) {
        searchBoxData.reportTimeBegin = this.formatDate(searchBoxData.reportTime[0]);
        searchBoxData.reportTimeEnd = this.formatDate(searchBoxData.reportTime[1]);
      } else {
        searchBoxData.reportTimeBegin = '';
        searchBoxData.reportTimeEnd = '';
      }
      if (searchBoxData.time && searchBoxData.time.length) {
        searchBoxData.startTime = this.formatDate(searchBoxData.time[0]);
        searchBoxData.endTime = this.formatDate(searchBoxData.time[1]);
      } else {
        searchBoxData.startTime = '';
        searchBoxData.endTime = '';
      }
      if (searchBoxData.createTime && searchBoxData.createTime.length) {
        searchBoxData.createTimeBegin = this.formatDate(searchBoxData.createTime[0]);
        searchBoxData.createTimeEnd = this.formatDate(searchBoxData.createTime[1]);
      } else {
        searchBoxData.createTimeBegin = '';
        searchBoxData.createTimeEnd = '';
      }
      delete searchBoxData.reportTime;
      delete searchBoxData.time;
      delete searchBoxData.createTime;
      this.$refs.tableBox.saveSearchBoxData(searchBoxData);
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'VEHICLE_ACCIDENT_STATE',
    });
    const safeEnum = (index) => (Array.isArray(enumsList) && Array.isArray(enumsList[index])) ? enumsList[index] : [];
    this.searchBoxData.accidentStateOptions = [
      {
        label: '全部',
        value: '-1',
      },
      ...safeEnum(0),
    ];
  },
};
</script>
<style lang="scss" scoped>
</style>
